import { ApiService } from './api.service'

export interface BulletinBoardEntry {
  id: string
  companyId: string
  content: string
  createdBy: string
  createdByName: string
  createdAt: Date
  updatedAt: Date
}

export interface CreateBulletinBoardEntryDto {
  content: string
}

export interface UpdateBulletinBoardEntryDto {
  content: string
}

class BulletinBoardService extends ApiService {
  async getAllByCompany(companyId: string): Promise<BulletinBoardEntry[]> {
    return this.handleResponse(
      this.api.get<BulletinBoardEntry[]>(`/bulletin-board/company/${companyId}`)
    )
  }

  async getById(id: string): Promise<BulletinBoardEntry> {
    return this.handleResponse(this.api.get<BulletinBoardEntry>(`/bulletin-board/${id}`))
  }

  async create(dto: CreateBulletinBoardEntryDto): Promise<BulletinBoardEntry> {
    return this.handleResponse(this.api.post<BulletinBoardEntry>('/bulletin-board', dto))
  }

  async update(id: string, dto: UpdateBulletinBoardEntryDto): Promise<BulletinBoardEntry> {
    return this.handleResponse(this.api.patch<BulletinBoardEntry>(`/bulletin-board/${id}`, dto))
  }

  async delete(id: string): Promise<void> {
    return this.handleResponse(this.api.delete(`/bulletin-board/${id}`))
  }
}

export const bulletinBoardService = new BulletinBoardService()
